"use strict";

(function () {
  var customSticky = document.querySelector(".product-interact");
  var contentSticky = document.querySelector(".custom-sticky");
  var viewportHeight = document.documentElement.clientHeight;
  function checkOffset() {
    var target = document.querySelector(".main-product-content");
    var accordions = document.querySelector(".accordions");
    var headerHeight = getComputedStyle(document.documentElement).getPropertyValue("--header-height");
    var heightValue = parseFloat(headerHeight);
    var rect = target.getBoundingClientRect();
    var scrollY = window.scrollY;
    var reach = heightValue - rect.top;
    var offset = viewportHeight - contentSticky.clientHeight + scrollY - viewportHeight + heightValue;
    // Stop sticky at the bottom of the reviewers section (if present), otherwise accordions
    var reviewersSection = document.querySelector('.iv-reviews');
    var capElement = reviewersSection || accordions;
    var accordionsCap = capElement
      ? capElement.getBoundingClientRect().bottom - rect.top - contentSticky.clientHeight
      : target.clientHeight - contentSticky.clientHeight - 33;
    offset = Math.min(offset, accordionsCap);
    if (reach > 0) {
      customSticky.classList.add("fixed");
      contentSticky.style.top = "".concat(offset + 28, "px");
    } else {
      customSticky.classList.remove("fixed");
      contentSticky.style.top = "0";
    }
  }
  function debounce(func, delay) {
    var timeoutId;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timeoutId);
      timeoutId = setTimeout(function () {
        func.apply(context, args);
      }, delay);
    };
  }
  checkOffset();
  var resize = function resize() {
    var vw = document.documentElement.clientWidth;
    if (vw > 750) {
      window.addEventListener("scroll", checkOffset);
    } else {
      window.removeEventListener("scroll", checkOffset);
    }
  };
  resize();
  var debouncedCheckOffset = debounce(checkOffset, 50);
  window.addEventListener("resize", debounce(resize, 50));
  var body = document.body;
  var observer = new ResizeObserver(function (entries) {
    debouncedCheckOffset();
  });
  observer.observe(body);
  var content = document.querySelector(".main-product-content");
  var beforeNode = document.querySelector(".main-product-content .description-more");
  var contentHeight = content.clientHeight;
  var contentWidth = content.clientWidth;
  var readMore = document.createElement("span");
  readMore.classList.add("read-more");
  readMore.innerHTML = "\n        <button>read more</button>\n";
  var desc = document.querySelector(".product-description");
  function checkOverflow() {
    if (desc.scrollHeight > desc.clientHeight) {
      readMore.classList.add("block");
      content.insertBefore(readMore, beforeNode);
    }
  }
  checkOverflow();
  readMore.addEventListener("click", function () {
    if (desc.classList.contains("expanded")) {
      content.insertBefore(readMore, beforeNode);
      desc.classList.remove("expanded");
      readMore.classList.remove("inline");
      readMore.classList.add("block");
      readMore.querySelector("button").textContent = "read more";
    } else {
      desc.classList.add("expanded");
      content.removeChild(readMore);
      readMore.classList.remove("block");
      readMore.classList.add("inline");
      desc.classList.add("expanded");
      readMore.querySelector("button").textContent = "read less";
      readMore.style.position = "relative";
      desc.querySelector("p:last-child").appendChild(readMore);
    }
  });
})();
(function () {
  function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  var isMobile = isMobileDevice();
  if (isMobile) {
    var target = document.querySelector(".product-form__buttons");
    if (!target) return;
    var targetOffsetTop = target.getBoundingClientRect().top;
    var listener = function listener() {
      var footer = document.querySelector(".inselberg-footer");
      if (!footer) return;
      var footerTop = footer.offsetTop - window.innerHeight;
      var scrollY = window.scrollY;
      if (scrollY > footerTop) {
        target.classList.add("hidden");
      } else if (scrollY > targetOffsetTop) {
        target.classList.add("fixed");
        target.classList.remove("hidden");
      } else {
        target.classList.remove("hidden");
        target.classList.remove("fixed");
      }
    };
    window.addEventListener("scroll", listener);
    listener();
  }
})();